<template>
  <div style="width: 100%; position: relative">
    <transition :name="transitionName" mode="out-in" v-if="$route.meta.isNeedKeepAlive" >
      <keep-alive>
        <router-view/>
      </keep-alive>
    </transition>

    <transition :name="transitionName" mode="out-in" v-if="!$route.meta.isNeedKeepAlive">
      <router-view key="router-view"/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'children',
  data () {
    return {
      isKeepAlive: false,
      transitionName: ''
    }
  },
  watch: {
    $route (to, from) {
      if (!from.meta.index) {
        this.transitionName = "page-slide-left";
      }
      if (to.meta.index < from.meta.index) {
        this.transitionName = "page-slide-right";
      } else if (to.meta.index === from.meta.index) {
        this.transitionName = "page-slide-left";
      } else {
        this.transitionName = "page-slide-left";
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit('changeListKeepAlive', {isReset: true, isInitPageNo: true, isQueryList: true, isQuerySelect: true})
    })
  },
  beforeRouteUpdate(to, from, next) {
    if (to.meta.isNeedKeepAlive) {
      if (from.meta.isBackKeepAlive) {
        this.$store.commit('changeListKeepAlive', {isReset: false, isInitPageNo: false, isQueryList: true, isQuerySelect: true})
      } else {
        this.$store.commit('changeListKeepAlive', {isReset: true, isInitPageNo: true, isQueryList: true, isQuerySelect: true})
      }
    }
    next()
  }
}
</script>
